import React from "react";
import ModalFormUI from "../../../widgets/form/ModalFormUI";
import InputTextSF from "../../../widgets/form/InputTextSF";
import InputSelectSF from "../../../widgets/form/InputSelectSF";

const CustomerCreateModalUI = ({context, successMsg, errorList, setErrorList,
   createMode, onSubmit, submitted, onCancelCreate, contactFirstName, onContactFirstNameChange, contactFirstNameError,
   setContactFirstNameError, contactLastName, onContactLastNameChange, setContactLastNameError, contactLastNameError,
   contactPhone, onContactPhoneChange, setContactPhoneError, contactPhoneError, contactEmail, onContactEmailChange,
   setContactEmailError, contactEmailError, panNumber, onPanNumberChange, setPanNumberError, panNumberError,
   state, stateList, onStateChange, setStateError, stateError, city, onCityChange, setCityError, cityError, postalCode, 
   onPostalCodeChange, setPostalCodeError, postalCodeError, streetAddress, onStreetAddressChange, setStreetAddressError,
   streetAddressError, CollectionDueInDays, onCollectionDueInDaysChange, setCollectionDueInDaysError, CollectionDueInDaysError,
}) => 
    <ModalFormUI
      context={context}
      titleLabel='Create customer'
      buttonLabel='Create customer'
      cancelLabel='Cancel'
      isOpen={createMode}
      onRequestClose={onCancelCreate}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      onSubmit={onSubmit}
      busy={submitted}
    >
    <div className='g_flex_h g_flex_top'>
      <div className='col'>
        <InputTextSF type='text' name='s_panNumber' required={true} maxLength={12}
          label='PAN Number' autoFocus={true}
          value={panNumber} onChange={onPanNumberChange}
          error={panNumberError} setError={setPanNumberError}
        />

        <InputTextSF type='text' name='s_firstName' maxLength={12}
          label='Contact first name'
          value={contactFirstName} onChange={onContactFirstNameChange}
          error={contactFirstNameError} setError={setContactFirstNameError}
        />
        <InputTextSF type='text' name='s_LastName' maxLength={12}
          label='Contact last name'
          value={contactLastName} onChange={onContactLastNameChange}
          error={contactLastNameError} setError={setContactLastNameError}
        />
        <InputTextSF type='text' name='s_phone' maxLength={12}
          label='Phone number'
          value={contactPhone} onChange={onContactPhoneChange}
          error={contactPhoneError} setError={setContactPhoneError}
        />
        <InputTextSF type='text' name='s_email' maxLength={100}
          label='Email'
          value={contactEmail} onChange={onContactEmailChange}
          error={contactEmailError} setError={setContactEmailError}
        />
      </div>
      <div className='g_m_left_100'>
        <InputTextSF type='text' name='s_streetAddress' maxLength={12}
          label='Address'
          value={streetAddress} onChange={onStreetAddressChange}
          error={streetAddressError} setError={setStreetAddressError}
        />
        <InputTextSF type='text' name='s_city' maxLength={12}
          label='City'
          value={city} onChange={onCityChange}
          error={cityError} setError={setCityError}
        />
        <InputTextSF type='text' name='s_postalCode' maxLength={12}
          label='Postal code'
          value={postalCode} onChange={onPostalCodeChange}
          error={postalCodeError} setError={setPostalCodeError}
        />
        <InputSelectSF type='select' name='state'
          label='State' required={true}
          value={state} onChange={onStateChange} optionList={stateList}
          error={stateError} setError={setStateError}
        />
        <InputTextSF type='text' name='s_CollectionDueInDays' maxLength={4}
          label='Collection due in days'
          value={CollectionDueInDays} onChange={onCollectionDueInDaysChange}
          error={CollectionDueInDaysError} setError={setCollectionDueInDaysError}
        />
      </div>
    </div>
  </ModalFormUI>

export default CustomerCreateModalUI;